import { DropzoneConfigInterface } from "ngx-dropzone-wrapper";

export class DropZoneSettings {
  public static readonly default: DropzoneConfigInterface = {
    maxFilesize: 5, // MB
    maxFiles: 1, // number of files accepted
    acceptedFiles: "image/jpeg,image/png", // Only JPG and PNG files accepted (no SVG, GIF, etc.)
    createImageThumbnails: false, // don't create a preview image
    parallelUploads: 1, // only 1 photo in parallel since we need unique endpoints for each
  };

  public static readonly excelFileConfig: DropzoneConfigInterface = {
    ...DropZoneSettings.default,
    acceptedFiles: ".xlsx",
  };

  public static readonly defaultPlaceholderImagePath: string =
    "/assets/images/components/cz-assessment/section-img-upload/icon-upload.png";
}
